<template>
    <div class="log-manager">
        <p class="plugin-header">
            日志管理 <span class="icon-glyphicon-info-sign colorcc" data-toggle="tooltip" data-placement="right"
                data-container="body" title="" data-original-title="操作图层和操作类型筛选的数据为2022年11月11日后删除的数据，此前数据不可筛选"></span>
        </p>
        <div class="map-log-panel map-log-filter">
            <div class="text-left dt-mar12b dt-line-30h">
                <span class="log-label">团队成员：</span>
                <select id="orgUser" class="input-log">
                    <option value="-1">全部</option>
                    <option value="151564">Paul_wsl</option>
                    <option value="557330">17276628757</option>
                </select>
                <span class="icon-glyphicon-info-sign colorcc" data-toggle="tooltip" data-placement="right"
                    data-container="body" title="" data-original-title="团队成员包括现有成员，也包括退出或被移除团队的成员"></span>
            </div>
            <div class="text-left dt-mar12b dt-line-30h">
                <span class="log-label">操作图层：</span>
                <select id="logLayer" class="input-log">
                    <option value="-1">全部</option>
                    <option value="m_2516209">品牌网点</option>
                    <option value="l_329946">线路图层1</option>
                    <option value="r_1282377">品牌网点周边3km</option>
                    <option value="r_1282376">格网分析 3km 汽配店</option>
                    <option value="r_1282375">格网分析 5km 小区</option>
                    <option value="r_1282374">东莞32个镇区潜力指数</option>
                </select>
                <span class="icon-glyphicon-info-sign colorcc" data-toggle="tooltip" data-placement="right"
                    data-container="body" title="" data-original-title="操作图层包括地图现有图层，也包括被删除的图层"></span>
            </div>
            <div class="text-left dt-mar12b dt-line-30h">
                <span class="log-label">操作类型：</span>
                <select id="operate" class="input-log">
                    <option value="-1">全部</option>
                    <option value="新增">新增</option>
                    <option value="修改">修改</option>
                    <option value="导入">导入</option>
                    <option value="复制">复制</option>
                    <option value="上传">上传</option>
                    <option value="分析">分析</option>
                    <option value="下载">下载</option>
                    <option value="删除">删除</option>
                    <option value="清除">清除</option>
                    <option value="恢复">恢复</option>
                    <option value="分派">分派</option>
                    <option value="退出">退出</option>
                    <option value="权限回收">权限回收</option>
                    <option value="其他">其他</option>
                </select>
            </div>
            <div class="text-left dt-mar12b dt-line-30h">
                <span class="log-label">操作时间：</span>
                <input id="startTime" type="text" class="input-log-date" placeholder="开始日期" autocomplete="off">
                <span class="">-</span>
                <input id="endTime" type="text" class="input-log-date" placeholder="结束日期" autocomplete="off">
            </div>
            <div class="g-justify-content">
                <div id="logRecordsTotal">共 23 条记录</div>
                <div>
                    <a href="javascript:void(0)" id="log-filter-reset" class="btn btn-primary btn-sm dt-w64">重置</a>
                    <a href="javascript:void(0)" id="log-filter-submit" class="btn btn-primary btn-sm dt-w64 dt-mar12l"
                        data-type="create">确认</a>
                </div>
            </div>
        </div>
        <div class="map-log-panel map-logs-details dt-auto">


            <div class="log-details dt-hidden dt-line-40h dt-pad12x dt-pad8y dt-border-be3 dt-pos-r">
                <div class="dt-pos-a">
                    <img src="https://assets-v3.changjing.com.cn/uploads/avatars/2025/4/22/304544d91b73781a5ec14bfe67f90762.png"
                        width="32" height="32" class="img-circle">
                </div>
                <div class="dt-mar6l dt-line-20h dt-f12 color77" style="margin-left:40px;">
                    <span class="color77 log_user_name dt-line-44h dt-truncate"
                        style="display:inline-block; max-width:65px;" title="17276628757">17276628757</span>
                    <span class="dt-gray log_create_time pull-right">2025-04-28 17:45:48</span>
                    <hr style="margin-top:6px;margin-bottom:4px;">
                    <span class="logt_content">

                        将地图名称《【副本】汽修服务连锁加盟市场分析_2025-04-22 14:30:54》修改为《【副本】汽修服务连锁加盟市场分析_2025-04-22 14:30:54》

                    </span>
                </div>
            </div>

            <div class="log-details dt-hidden dt-line-40h dt-pad12x dt-pad8y dt-border-be3 dt-pos-r">
                <div class="dt-pos-a">
                    <img src="https://assets-v3.changjing.com.cn/uploads/avatars/2025/4/22/304544d91b73781a5ec14bfe67f90762.png"
                        width="32" height="32" class="img-circle">
                </div>
                <div class="dt-mar6l dt-line-20h dt-f12 color77" style="margin-left:40px;">
                    <span class="color77 log_user_name dt-line-44h dt-truncate"
                        style="display:inline-block; max-width:65px;" title="17276628757">17276628757</span>
                    <span class="dt-gray log_create_time pull-right">2025-04-28 11:47:05</span>
                    <hr style="margin-top:6px;margin-bottom:4px;">
                    <span class="logt_content">

                        修改了插件设置

                    </span>
                </div>
            </div>

            <div class="log-details dt-hidden dt-line-40h dt-pad12x dt-pad8y dt-border-be3 dt-pos-r">
                <div class="dt-pos-a">
                    <img src="https://assets-v3.changjing.com.cn/uploads/avatars/2025/4/22/304544d91b73781a5ec14bfe67f90762.png"
                        width="32" height="32" class="img-circle">
                </div>
                <div class="dt-mar6l dt-line-20h dt-f12 color77" style="margin-left:40px;">
                    <span class="color77 log_user_name dt-line-44h dt-truncate"
                        style="display:inline-block; max-width:65px;" title="17276628757">17276628757</span>
                    <span class="dt-gray log_create_time pull-right">2025-04-28 11:46:42</span>
                    <hr style="margin-top:6px;margin-bottom:4px;">
                    <span class="logt_content">

                        修改了插件设置

                    </span>
                </div>
            </div>

            <div class="log-details dt-hidden dt-line-40h dt-pad12x dt-pad8y dt-border-be3 dt-pos-r">
                <div class="dt-pos-a">
                    <img src="https://assets-v3.changjing.com.cn/uploads/avatars/2025/4/22/304544d91b73781a5ec14bfe67f90762.png"
                        width="32" height="32" class="img-circle">
                </div>
                <div class="dt-mar6l dt-line-20h dt-f12 color77" style="margin-left:40px;">
                    <span class="color77 log_user_name dt-line-44h dt-truncate"
                        style="display:inline-block; max-width:65px;" title="17276628757">17276628757</span>
                    <span class="dt-gray log_create_time pull-right">2025-04-28 05:33:42</span>
                    <hr style="margin-top:6px;margin-bottom:4px;">
                    <span class="logt_content">

                        将地图名称《【副本】汽修服务连锁加盟市场分析_2025-04-22 14:30:54》修改为《【副本】汽修服务连锁加盟市场分析_2025-04-22 14:30:54》

                    </span>
                </div>
            </div>

            <div class="log-details dt-hidden dt-line-40h dt-pad12x dt-pad8y dt-border-be3 dt-pos-r">
                <div class="dt-pos-a">
                    <img src="https://assets-v3.changjing.com.cn/uploads/avatars/2025/4/22/304544d91b73781a5ec14bfe67f90762.png"
                        width="32" height="32" class="img-circle">
                </div>
                <div class="dt-mar6l dt-line-20h dt-f12 color77" style="margin-left:40px;">
                    <span class="color77 log_user_name dt-line-44h dt-truncate"
                        style="display:inline-block; max-width:65px;" title="17276628757">17276628757</span>
                    <span class="dt-gray log_create_time pull-right">2025-04-28 04:31:03</span>
                    <hr style="margin-top:6px;margin-bottom:4px;">
                    <span class="logt_content">

                        将地图名称《【副本】汽修服务连锁加盟市场分析_2025-04-22 14:30:54》修改为《【副本】汽修服务连锁加盟市场分析_2025-04-22 14:30:54》

                    </span>
                </div>
            </div>

            <div class="log-details dt-hidden dt-line-40h dt-pad12x dt-pad8y dt-border-be3 dt-pos-r">
                <div class="dt-pos-a">
                    <img src="https://assets-v3.changjing.com.cn/uploads/avatars/2025/4/22/304544d91b73781a5ec14bfe67f90762.png"
                        width="32" height="32" class="img-circle">
                </div>
                <div class="dt-mar6l dt-line-20h dt-f12 color77" style="margin-left:40px;">
                    <span class="color77 log_user_name dt-line-44h dt-truncate"
                        style="display:inline-block; max-width:65px;" title="17276628757">17276628757</span>
                    <span class="dt-gray log_create_time pull-right">2025-04-28 03:52:12</span>
                    <hr style="margin-top:6px;margin-bottom:4px;">
                    <span class="logt_content">

                        在标注图层&lt;品牌网点&gt;添加了标注&lt;标注2&gt;

                    </span>
                </div>
            </div>

            <div class="log-details dt-hidden dt-line-40h dt-pad12x dt-pad8y dt-border-be3 dt-pos-r">
                <div class="dt-pos-a">
                    <img src="https://assets-v3.changjing.com.cn/uploads/avatars/2025/4/22/304544d91b73781a5ec14bfe67f90762.png"
                        width="32" height="32" class="img-circle">
                </div>
                <div class="dt-mar6l dt-line-20h dt-f12 color77" style="margin-left:40px;">
                    <span class="color77 log_user_name dt-line-44h dt-truncate"
                        style="display:inline-block; max-width:65px;" title="17276628757">17276628757</span>
                    <span class="dt-gray log_create_time pull-right">2025-04-28 03:07:53</span>
                    <hr style="margin-top:6px;margin-bottom:4px;">
                    <span class="logt_content">

                        在区域图层&lt;品牌网点周边3km&gt;创建了区域&lt;区域3&gt;

                    </span>
                </div>
            </div>

            <div class="log-details dt-hidden dt-line-40h dt-pad12x dt-pad8y dt-border-be3 dt-pos-r">
                <div class="dt-pos-a">
                    <img src="https://assets-v3.changjing.com.cn/uploads/avatars/2025/4/22/304544d91b73781a5ec14bfe67f90762.png"
                        width="32" height="32" class="img-circle">
                </div>
                <div class="dt-mar6l dt-line-20h dt-f12 color77" style="margin-left:40px;">
                    <span class="color77 log_user_name dt-line-44h dt-truncate"
                        style="display:inline-block; max-width:65px;" title="17276628757">17276628757</span>
                    <span class="dt-gray log_create_time pull-right">2025-04-27 11:17:10</span>
                    <hr style="margin-top:6px;margin-bottom:4px;">
                    <span class="logt_content">

                        在标注图层&lt;品牌网点&gt;添加了标注&lt;标注2&gt;

                    </span>
                </div>
            </div>

            <div class="log-details dt-hidden dt-line-40h dt-pad12x dt-pad8y dt-border-be3 dt-pos-r">
                <div class="dt-pos-a">
                    <img src="https://assets-v3.changjing.com.cn/uploads/avatars/2025/4/22/304544d91b73781a5ec14bfe67f90762.png"
                        width="32" height="32" class="img-circle">
                </div>
                <div class="dt-mar6l dt-line-20h dt-f12 color77" style="margin-left:40px;">
                    <span class="color77 log_user_name dt-line-44h dt-truncate"
                        style="display:inline-block; max-width:65px;" title="17276628757">17276628757</span>
                    <span class="dt-gray log_create_time pull-right">2025-04-27 09:50:25</span>
                    <hr style="margin-top:6px;margin-bottom:4px;">
                    <span class="logt_content">

                        在线路图层&lt;线路图层1&gt;添加了线路&lt;线路1&gt;

                    </span>
                </div>
            </div>

            <div class="log-details dt-hidden dt-line-40h dt-pad12x dt-pad8y dt-border-be3 dt-pos-r">
                <div class="dt-pos-a">
                    <img src="https://assets-v3.changjing.com.cn/uploads/avatars/2025/4/22/304544d91b73781a5ec14bfe67f90762.png"
                        width="32" height="32" class="img-circle">
                </div>
                <div class="dt-mar6l dt-line-20h dt-f12 color77" style="margin-left:40px;">
                    <span class="color77 log_user_name dt-line-44h dt-truncate"
                        style="display:inline-block; max-width:65px;" title="17276628757">17276628757</span>
                    <span class="dt-gray log_create_time pull-right">2025-04-27 09:50:25</span>
                    <hr style="margin-top:6px;margin-bottom:4px;">
                    <span class="logt_content">

                        创建了线路图层&lt;线路图层1&gt;

                    </span>
                </div>
            </div>

            <div class="log-details dt-hidden dt-line-40h dt-pad12x dt-pad8y dt-border-be3 dt-pos-r">
                <div class="dt-pos-a">
                    <img src="https://assets-v3.changjing.com.cn/uploads/avatars/2025/4/22/304544d91b73781a5ec14bfe67f90762.png"
                        width="32" height="32" class="img-circle">
                </div>
                <div class="dt-mar6l dt-line-20h dt-f12 color77" style="margin-left:40px;">
                    <span class="color77 log_user_name dt-line-44h dt-truncate"
                        style="display:inline-block; max-width:65px;" title="17276628757">17276628757</span>
                    <span class="dt-gray log_create_time pull-right">2025-04-27 02:50:05</span>
                    <hr style="margin-top:6px;margin-bottom:4px;">
                    <span class="logt_content">

                        修改了地图默认视图

                    </span>
                </div>
            </div>

            <div class="log-details dt-hidden dt-line-40h dt-pad12x dt-pad8y dt-border-be3 dt-pos-r">
                <div class="dt-pos-a">
                    <img src="https://assets-v3.changjing.com.cn/uploads/avatars/2025/4/22/304544d91b73781a5ec14bfe67f90762.png"
                        width="32" height="32" class="img-circle">
                </div>
                <div class="dt-mar6l dt-line-20h dt-f12 color77" style="margin-left:40px;">
                    <span class="color77 log_user_name dt-line-44h dt-truncate"
                        style="display:inline-block; max-width:65px;" title="17276628757">17276628757</span>
                    <span class="dt-gray log_create_time pull-right">2025-04-27 02:50:00</span>
                    <hr style="margin-top:6px;margin-bottom:4px;">
                    <span class="logt_content">

                        修改了地图默认视图

                    </span>
                </div>
            </div>

            <div class="log-details dt-hidden dt-line-40h dt-pad12x dt-pad8y dt-border-be3 dt-pos-r">
                <div class="dt-pos-a">
                    <img src="https://assets-v3.changjing.com.cn/uploads/avatars/2025/4/22/304544d91b73781a5ec14bfe67f90762.png"
                        width="32" height="32" class="img-circle">
                </div>
                <div class="dt-mar6l dt-line-20h dt-f12 color77" style="margin-left:40px;">
                    <span class="color77 log_user_name dt-line-44h dt-truncate"
                        style="display:inline-block; max-width:65px;" title="17276628757">17276628757</span>
                    <span class="dt-gray log_create_time pull-right">2025-04-27 02:49:41</span>
                    <hr style="margin-top:6px;margin-bottom:4px;">
                    <span class="logt_content">

                        显示了所有图层

                    </span>
                </div>
            </div>

            <div class="log-details dt-hidden dt-line-40h dt-pad12x dt-pad8y dt-border-be3 dt-pos-r">
                <div class="dt-pos-a">
                    <img src="https://assets-v3.changjing.com.cn/uploads/avatars/2025/4/22/304544d91b73781a5ec14bfe67f90762.png"
                        width="32" height="32" class="img-circle">
                </div>
                <div class="dt-mar6l dt-line-20h dt-f12 color77" style="margin-left:40px;">
                    <span class="color77 log_user_name dt-line-44h dt-truncate"
                        style="display:inline-block; max-width:65px;" title="17276628757">17276628757</span>
                    <span class="dt-gray log_create_time pull-right">2025-04-27 02:49:36</span>
                    <hr style="margin-top:6px;margin-bottom:4px;">
                    <span class="logt_content">

                        隐藏了所有图层

                    </span>
                </div>
            </div>

            <div class="log-details dt-hidden dt-line-40h dt-pad12x dt-pad8y dt-border-be3 dt-pos-r">
                <div class="dt-pos-a">
                    <img src="https://assets-v3.changjing.com.cn/uploads/avatars/2025/4/22/304544d91b73781a5ec14bfe67f90762.png"
                        width="32" height="32" class="img-circle">
                </div>
                <div class="dt-mar6l dt-line-20h dt-f12 color77" style="margin-left:40px;">
                    <span class="color77 log_user_name dt-line-44h dt-truncate"
                        style="display:inline-block; max-width:65px;" title="17276628757">17276628757</span>
                    <span class="dt-gray log_create_time pull-right">2025-04-27 02:49:35</span>
                    <hr style="margin-top:6px;margin-bottom:4px;">
                    <span class="logt_content">

                        显示了所有图层

                    </span>
                </div>
            </div>

            <div class="log-details dt-hidden dt-line-40h dt-pad12x dt-pad8y dt-border-be3 dt-pos-r">
                <div class="dt-pos-a">
                    <img src="https://assets-v3.changjing.com.cn/uploads/avatars/2025/4/22/304544d91b73781a5ec14bfe67f90762.png"
                        width="32" height="32" class="img-circle">
                </div>
                <div class="dt-mar6l dt-line-20h dt-f12 color77" style="margin-left:40px;">
                    <span class="color77 log_user_name dt-line-44h dt-truncate"
                        style="display:inline-block; max-width:65px;" title="17276628757">17276628757</span>
                    <span class="dt-gray log_create_time pull-right">2025-04-27 02:49:34</span>
                    <hr style="margin-top:6px;margin-bottom:4px;">
                    <span class="logt_content">

                        隐藏了所有图层

                    </span>
                </div>
            </div>

            <div class="log-details dt-hidden dt-line-40h dt-pad12x dt-pad8y dt-border-be3 dt-pos-r">
                <div class="dt-pos-a">
                    <img src="https://assets-v3.changjing.com.cn/uploads/avatars/2025/4/22/304544d91b73781a5ec14bfe67f90762.png"
                        width="32" height="32" class="img-circle">
                </div>
                <div class="dt-mar6l dt-line-20h dt-f12 color77" style="margin-left:40px;">
                    <span class="color77 log_user_name dt-line-44h dt-truncate"
                        style="display:inline-block; max-width:65px;" title="17276628757">17276628757</span>
                    <span class="dt-gray log_create_time pull-right">2025-04-27 02:49:21</span>
                    <hr style="margin-top:6px;margin-bottom:4px;">
                    <span class="logt_content">

                        在图层&lt;格网分析 3km 汽配店&gt;执行了获取数据密钥

                    </span>
                </div>
            </div>

            <div class="log-details dt-hidden dt-line-40h dt-pad12x dt-pad8y dt-border-be3 dt-pos-r">
                <div class="dt-pos-a">
                    <img src="https://assets-v3.changjing.com.cn/uploads/avatars/2017/10/30/430e4928aed53829d4a22486a1aa4f10.png"
                        width="32" height="32" class="img-circle">
                </div>
                <div class="dt-mar6l dt-line-20h dt-f12 color77" style="margin-left:40px;">
                    <span class="color77 log_user_name dt-line-44h dt-truncate"
                        style="display:inline-block; max-width:65px;" title="Paul_wsl">Paul_wsl</span>
                    <span class="dt-gray log_create_time pull-right">2025-04-22 14:31:05</span>
                    <hr style="margin-top:6px;margin-bottom:4px;">
                    <span class="logt_content">

                        创建了标注图层&lt;品牌网点&gt;

                    </span>
                </div>
            </div>

            <div class="log-details dt-hidden dt-line-40h dt-pad12x dt-pad8y dt-border-be3 dt-pos-r">
                <div class="dt-pos-a">
                    <img src="https://assets-v3.changjing.com.cn/uploads/avatars/2017/10/30/430e4928aed53829d4a22486a1aa4f10.png"
                        width="32" height="32" class="img-circle">
                </div>
                <div class="dt-mar6l dt-line-20h dt-f12 color77" style="margin-left:40px;">
                    <span class="color77 log_user_name dt-line-44h dt-truncate"
                        style="display:inline-block; max-width:65px;" title="Paul_wsl">Paul_wsl</span>
                    <span class="dt-gray log_create_time pull-right">2025-04-22 14:31:04</span>
                    <hr style="margin-top:6px;margin-bottom:4px;">
                    <span class="logt_content">

                        创建了区域图层&lt;品牌网点周边3km&gt;

                    </span>
                </div>
            </div>

            <div class="log-details dt-hidden dt-line-40h dt-pad12x dt-pad8y dt-border-be3 dt-pos-r">
                <div class="dt-pos-a">
                    <img src="https://assets-v3.changjing.com.cn/uploads/avatars/2017/10/30/430e4928aed53829d4a22486a1aa4f10.png"
                        width="32" height="32" class="img-circle">
                </div>
                <div class="dt-mar6l dt-line-20h dt-f12 color77" style="margin-left:40px;">
                    <span class="color77 log_user_name dt-line-44h dt-truncate"
                        style="display:inline-block; max-width:65px;" title="Paul_wsl">Paul_wsl</span>
                    <span class="dt-gray log_create_time pull-right">2025-04-22 14:30:57</span>
                    <hr style="margin-top:6px;margin-bottom:4px;">
                    <span class="logt_content">

                        创建了区域图层&lt;格网分析 3km 汽配店&gt;

                    </span>
                </div>
            </div>



            <div class="more-log-loading text-center dt-pad4x dt-pad8y"><a type="button" href="###"
                    class="btn btn-link log-loading dt-f12">加载更多...</a></div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'LogManager',
    components: {

    },
    data() {
        return {

        }
    },
    mounted() {


    },
    methods: {


    }
}

</script>

<style scoped>
.log-manager {
    position: relative;
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    scrollbar-width: none;
}

.plugin-header {
    height: 36px;
    padding-left: 10px;
    padding-right: 10px;
    background-color: #edf0f5;
    line-height: 36px;
    color: #576d8b;
}
.map-log-panel {
    position: relative;
    background-color: #fff;
    width: 282px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.3);
}
.map-log-filter {
    padding: 8px 15px;
}
.text-left {
    text-align: left;
}
.dt-line-30h {
    line-height: 30px;
}
.dt-mar12b {
    margin-bottom: 12px;
}
.log-label {
    font-family: PingFangSC-Medium;
    font-size: 14px;
    color: #576d8b;
    letter-spacing: 0;
    text-align: left;
    width: 78px;

}
.input-log {
    display: inline-block;
    border: none;
    outline: none;
    font-size: 12px;
    background-color: #edf0f5;
    height: 26px;
    width: 162px;
    padding: 0 8px;
    border-radius: 2px;
    color: #576d8b;
}
.colorcc {
    color: #ccc;
    margin-left: 3px;
}
.input-log-date {
    display: inline-block;
    border: none;
    outline: none;
    font-size: 12px;
    background-color: #edf0f5;
    height: 26px;
    width: 83px;
    padding: 0 8px;
    border-radius: 2px;
    color: #576d8b;
}
.btn-primary {
    color: #ffffff;
    background-color: #428bca;
    border-color: #357ebd;
}
.btn-primary {
    background-color: #0095ff;
    border-color: #0095ff;
}
.dt-w64 {
    width: 64px;
}
.g-justify-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.btn-sm, .btn-group-sm>.btn {
    padding: 5px 10px;
    font-size: 12px;
    line-height: 1.5;
    border-radius: 3px;
}
.btn {
    display: inline-block;
    margin-bottom: 0;
    font-weight: normal;
    text-align: center;
    vertical-align: middle;
    touch-action: manipulation;
    cursor: pointer;
    background-image: none;
    border: 1px solid transparent;
    white-space: nowrap;
    padding: 6px 12px;
    font-size: 14px;
    line-height: 1.42857143;
    border-radius: 4px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}
.dt-mar12l {
    margin-left: 12px;
}
.map-logs-details {
    height: calc(100% - 251px);
}
.map-log-panel {
    position: relative;
    background-color: #fff;
    width: 282px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.3);
}
.dt-pos-a{
    width:32px;
    float: left;
}
.dt-auto {
    overflow: auto;
}
.img-circle {
    border-radius: 50%;
}
img {
    vertical-align: middle;
}
img {
    border: 0;
}
.log-details {
    border-top-style: solid;
    border-bottom-style: solid;
    border-top-width: 2px;
    border-bottom-width: 2px;
    border-top-color: #edf0f5;
    border-bottom-color: #edf0f5;
}
.dt-hidden {
    overflow: hidden;
}
.dt-line-40h {
    line-height: 40px;
}
.dt-pos-r {
    position: relative;
}
.dt-pad8y {
    padding-top: 8px;
    padding-bottom: 8px;
}
.dt-pad12x {
    padding-left: 12px;
    padding-right: 12px;
}
.dt-line-20h {
    line-height: 20px;
}
.dt-f12 {
    font-size: 12px;
}
.color77 {
    color: #777;
}
.log_user_name {
    font-size: 14px;
    color: #576d8b;
}
.dt-truncate {
    display: inline-block;
    padding-left: 10px;
    padding-right: 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.dt-line-44h {
    line-height: 44px;
}
.log_create_time {
    font-size: 12px;
    color: #707e91;
    background-color: #edf0f5;
    padding: 0 6px;
    margin-top: 12px;
}
.pull-right {
    float: right !important;
}
</style>